import { useEffect, useState } from 'react';
import moment from 'moment';
import { formatMoneyKr } from '../../../utils/index';
import ProjectCardWrapper from '../../project-card/ProjectCardWrapper';
import Loading from '../../../components/Loading';
import styles from './project-card-payment.module.less';

const ProjectCardPayment = ({ project, subproject, baseURL }) => {
    const [transactionStats, setTransactionStats] = useState();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        fetch(`${baseURL}/api/public/transaction/${project.id}/stats`)
            .then((response) => {
                if (response.ok) {
                    return response.json();
                } else {
                    throw new Error('Could not get project stats');
                }
            })
            .catch(() => {})
            .then((transactionStats) => setTransactionStats(transactionStats))
            .finally(() => setLoading(false));
    }, [project.id, baseURL]);

    if (!project.profile?.showPaymentStats) {
        return (
            <div className={styles.container}>
                <ProjectCardWrapper clickable={false} project={project} />
            </div>
        );
    }

    if (loading) {
        return <Loading />;
    }

    const proposedTransactionNumber = project.giver_count + 1;
    const hasTransactions = project.transaction_count > 0;
    const hasStats = !!transactionStats;

    return (
        <div className={styles.container}>
            <ProjectCardWrapper clickable={false} project={project} subproject={subproject}>
                {hasTransactions && hasStats ? (
                    <div className={styles.statsContainer}>
                        <div className={styles.text}>
                            Du ligger an til å bli{' '}
                            <span className={styles.strong}>giver nummer {proposedTransactionNumber}</span>
                        </div>
                        <div>
                            Høyeste innbetaling
                            <div className={styles.bigText}>
                                {formatMoneyKr(transactionStats.max_transaction_amount)}
                            </div>
                        </div>
                        <div className={styles.text}>
                            Det er{' '}
                            <span className={styles.strong}>{`${moment(
                                transactionStats.last_transaction_timestamp
                            ).fromNow()}`}</span>{' '}
                            forrige innbetaling
                        </div>
                        <div>
                            Vanlig innbetaling
                            <div className={styles.bigText}>
                                {formatMoneyKr(transactionStats.median_transaction_amount)}
                            </div>
                        </div>
                    </div>
                ) : (
                    <p>Du ligger an til å bli den første til å støtte innsamlingen 🏆</p>
                )}
            </ProjectCardWrapper>
        </div>
    );
};

export default ProjectCardPayment;
